import React from 'react'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import Leftbar from '../Components/Sidebar/Leftbar'
import StudentList from '../Components/Student/StudentList'

function StudentPage() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC', overflowX: 'hidden', width: '100%' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          /* marginLeft: '20px', */
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
          overflowX: 'hidden',
          minWidth: 0,
        }}
      >
        <div style={{ flex: 1, padding: 24, minHeight: 0, overflowX: 'hidden', width: '100%', boxSizing: 'border-box' }}>
          <SHeaderbar />
          <StudentList />
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}

export default StudentPage
